import React from "react";
import { Modal, Button } from "antd";

export function ConfirmationModal({ visible, removeImage, closeModal }) {
  const onButtonClick = () => {
    removeImage();
    closeModal();
  };

  return (
    <Modal
      visible={visible}
      onCancel={closeModal}
      centered
      footer={[
        <Button
          key="cancel"
          /* @ts-expect-error FIXME this wrong type */
          type="secondary"
          onClick={closeModal}
        >
          No
        </Button>,
        <Button key="submit" type="primary" onClick={onButtonClick}>
          Yes
        </Button>,
      ]}
    >
      Are you sure you want to remove the time card template?
    </Modal>
  );
}
